/* eye.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" xml:space="preserve">
<title>View</title>
<path class="foreground-gl" d="M16 6c-6.667 0-12.36 4.147-14.667 10 2.307 5.853 8 10 14.667 10s12.36-4.147 14.667-10c-2.307-5.853-8-10-14.667-10zM16 22.667c-3.68 0-6.667-2.987-6.667-6.667s2.987-6.667 6.667-6.667c3.68 0 6.667 2.987 6.667 6.667s-2.987 6.667-6.667 6.667zM16 12c-2.213 0-4 1.787-4 4s1.787 4 4 4c2.213 0 4-1.787 4-4s-1.787-4-4-4z"></path>
</svg>
     `
};
